module.exports = __webpack_public_path__ + "img/frame.5a9a96c0.svg";